module.exports = __webpack_public_path__ + "static/IOLCF-BOD-Nomination-Form-65c47240be4b3949a5a16df8761d258b.pdf";